import React, { useState, useEffect } from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import TablaGeneral from "../../components/TablaGeneral";
import Loader from "../../components/Loader";
import configTable from "../../hook/configTable";
import { apiFetch } from "../../utils/api";

const TorneosPage = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [datos, setDatos] = useState([])

  const eliminarItem = async (id) => {
    console.log('eliminarItem', id);
    setIsLoading(true);
    try {
      const data = await apiFetch(`/api/tournaments/${id}`,{
        method: "DELETE",
      });
      if(data.status){
        setDatos([])
        cargarDatos();
      } else {
        window.notie?.alert({ type: "warning", text: data.message || "No se pudo eliminar el torneo" });
        setIsLoading(false);
      }
    } catch (error) {
      console.error('Error:', error);
      setIsLoading(false);
    }
  }

  const [datosTabla] = useState({
    titulo: "Torneos",
    ruta: "/torneo",
    esAgregar: true,
    esEditar: true,
    esEliminar: true,
    eliminar: eliminarItem,
    configTable: configTable,
  })

  const [cabecera] = useState([
    { title: "ID", key: "id" },
    { title: "NOMBRE", key: "name" },
    { title: "SUCURSAL", key: "branch.nombre" },
    { title: "ESTATUS", key: "status" },
    { title: "INICIO", key: "startsAt", isDate: true },
    { title: "FECHA ALTA", key: "createdAt", isDate: true }
  ]);

  const cargarDatos = async () => {
    try {
      const data = await apiFetch("/api/tournaments", { method: "GET" });
      if(data.status){
        setDatos(Array.isArray(data.data?.items) ? data.data.items : Array.isArray(data.data) ? data.data : []);
      } else {
        setDatos([]);
        window.notie?.alert({ type: "warning", text: data.message || "No se pudieron cargar los torneos" });
      }
    } catch (error) {
      console.error('Error:', error);
      setDatos([]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    cargarDatos();
  }, []);
  return (
    <>
      <MasterLayout>
      { isLoading ? <Loader /> : <TablaGeneral datosTabla={datosTabla} datos={datos} cabecera={cabecera}/> }
      </MasterLayout>
    </>
  );
};

export default TorneosPage;
